import React, { useState } from 'react';

// Görevleri durum sütunlarında gösterir; kart sürüklenip başka sütuna bırakılınca durum değişir.
export default function TaskKanban({ tasks, statuses, onMove, onOpen, formatDue }) {
  const [over, setOver] = useState(null);
  return (
    <div className="kb">
      {statuses.map(([key, st]) => {
        const col = tasks.filter(t => t.status === key);
        return (
          <div key={key}
            className={`kb__col ${over === key ? 'kb__col--over' : ''}`}
            onDragOver={(e) => { e.preventDefault(); setOver(key); }}
            onDragLeave={() => setOver(o => (o === key ? null : o))}
            onDrop={(e) => {
              e.preventDefault(); setOver(null);
              const id = Number(e.dataTransfer.getData('text/plain'));
              const t = tasks.find(x => x.id === id);
              if (t && t.status !== key) onMove(id, key);
            }}>
            <div className="kb__head">
              <span className="kb__dot" style={{ background: st.color }} />
              {st.label}
              <span className="kb__count">{col.length}</span>
            </div>
            <div className="kb__list">
              {col.map(t => (
                <div key={t.id} className="kb__card" draggable
                  onDragStart={(e) => e.dataTransfer.setData('text/plain', String(t.id))}
                  onClick={() => onOpen(t)}>
                  <div className="kb__title">{t.title}</div>
                  {(t.account_name || t.company) && <div className="kb__brand">{t.account_name || t.company}</div>}
                  <div className="kb__meta">
                    <span>{Array.isArray(t.assignees) && t.assignees.length ? t.assignees.map(a => a.name.split(' ')[0]).join(', ') : (t.assigned_name || 'Atanmamış')}</span>
                    {t.due_date && <span>{formatDue(t.due_date)}</span>}
                    {t.comment_count > 0 && <span>{t.comment_count} yorum</span>}
                  </div>
                </div>
              ))}
              {col.length === 0 && <div className="kb__empty">Görev yok</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
